import { EDLookupLayout, EDHazardousLayout } from '../../../../../../common/lookups/Layouts/EDLayouts';
import { IMProductCategoryLookupLayout, IMFeesLookupLayout } from "../../../../../../common/lookups/Layouts/ImLayouts"
import { OMCodesLookupLayout } from '../../../../../../common/lookups/Layouts/OMLayouts';

const eDLookupLayout = EDLookupLayout({ Dataelementnum: '355', Versionid: '4010' });

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "Item",
        "fields": [
            {
                "name": "ItemDescription1",
                "tableName": "OMTRANSACTIONHEADER",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            },
            {
                "name": "ItemDescription2",
                "tableName": "OMTRANSACTIONHEADER",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            }
            ,
            {
                "name": "ItemAvailable",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Available",
                "type": "number","format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            },
            {
                "name": "ItemNetAvailable",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Net Avl:",
                "type": "number","format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            }
            ,
            {
                "name": "InventoryUnitUOM",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "UOM",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Lot",
        "fields": [
            {
                "name": "LotDescription1",
                "tableName": "OMTRANSACTIONHEADER",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            },
            {
                "name": "LotDescription2",
                "tableName": "OMTRANSACTIONHEADER",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            }
            ,
            {
                "name": "LotAvailable",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Available",
                "type": "number","format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            },
            {
                "name": "LotNetAvailable",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "Net Avl:",
                "type": "number","format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            }
            ,
            {
                "name": "LotUOM",
                "tableName": "OMTRANSACTIONHEADER",
                "label": "UOM",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "readOnly": true
            }
        ]
    }

]
const AdditionalLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UnitOfMeasure",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "lookup",
                "layout": eDLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "UOM",
            },
            {
                "name": "RProductcategory",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "lookup",
                "layout": IMProductCategoryLookupLayout(),
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Prod Category",
            }
            ,
            {
                "name": "Taxableflag",
                "tableName": "OMTRANSACTIONDETAIL",
                "label": "Available",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Taxable",
            },
            {
                "name": "Pickstatus",
                "tableName": "OMTRANSACTIONDETAIL",
                "label": "Net Avl:",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Pick Status",
            }
            ,
            {
                "name": "Artradediscountflag",
                "tableName": "OMTRANSACTIONDETAIL",
                "label": "UOM",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Trade Disc",
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Artermsdiscountflag",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "AR Terms Disc",
            },
            {
                "name": "Shippingdate",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Ship Date",
            }
            ,
            {
                "name": "RFees",
                "tableName": "OMTRANSACTIONDETAIL",
                "label": "Available",
                "type": "lookup",
                "layout": IMFeesLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Fees",
            },
            {
                "name": "Feesadded",
                "tableName": "OMTRANSACTIONDETAIL",
                "label": "Net Avl:",
                "type": "number","format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Fees Added",
            }
            ,
            {
                "name": "Feesincluded",
                "tableName": "OMTRANSACTIONDETAIL",
                "label": "UOM",
                "type": "number","format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Fees Included",
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "Originalquantityordered",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number","format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Original Order",
            },
            {
                "name": "Discountpercent",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number","format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Item Discount",
            }
            ,
            {
                "name": "DiscountedPrice",
                "tableName": "OMTRANSACTIONDETAIL",
                "label": "Available",
                "type": "number","format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Disc. Price",
                "readOnly": false,
            },
            {
                "name": "Referencenumber",
                "tableName": "OMTRANSACTIONDETAIL",
                "label": "Net Avl:",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Reference #",
            }
            ,
            {
                "name": "Alternatedescription",
                "tableName": "OMTRANSACTIONDETAIL",
                "label": "UOM",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Alt. Desc",
            }
        ]
    },
]
const UserDefinedLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Userdefinedcode1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IMITEM",
                "label": "CODE 2",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '12' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedcode2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IMITEM",
                "label": "CODE 2",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '13' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedcode3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IMITEM",
                "label": "CODE 3",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '14' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedcode4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IMITEM",
                "label": "CODE 4",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '15' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedcode5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IMITEM",
                "label": "CODE 4",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '16' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Userdefineddate1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IMITEM",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IMITEM",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IMITEM",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IMITEM",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IMITEM",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "Userdefinedquantity1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IMITEM",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IMITEM",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IMITEM",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IMITEM",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IMITEM",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Userdefinedreference1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IMITEM",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IMITEM",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IMITEM",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IMITEM",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IMITEM",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const UserDefinedLayout1 = [

    {
        "groupId": 1,
        "label": "",
        "fields": [

            {
                "name": "Userdefinedcode6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IMITEM",
                "label": "CODE 6",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '33' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedcode7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IMITEM",
                "label": "CODE 7",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '34' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedcode8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IMITEM",
                "label": "CODE 8",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '35' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedcode9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IMITEM",
                "label": "CODE 9",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '36' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedcode10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IMITEM",
                "label": "CODE 10",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '37' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [

            {
                "name": "Userdefineddate6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IMITEM",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IMITEM",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IMITEM",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IMITEM",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefineddate10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IMITEM",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [

            {
                "name": "Userdefinedquantity6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IMITEM",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IMITEM",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IMITEM",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IMITEM",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedquantity10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IMITEM",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },

    {
        "groupId": 1,
        "label": "",
        "fields": [

            {
                "name": "Userdefinedreference6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IMITEM",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IMITEM",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IMITEM",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IMITEM",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Userdefinedreference10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IMITEM",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const CommentLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "UserDefinedComment",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Primary Comment",
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Comment",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "User-Defined Comment",
            },
        ]
    }
]
const AlternateSKULayout = [
    {
        "groupId": 1,
        "label": "Item SKU",
        "fields": [
            {
                "name": "Itemsupccode",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Alternate SKU",
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Lot SKU",
        "fields": [
            {
                "name": "Lotupccode",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Alternate SKU",
                "readOnly": true,
            },
        ]
    },
    {
        "groupId": 3,
        "label": "Customer Cross-Reference SKU",
        "fields": [
            {
                // OMTRANSACTIONDETAIL.CUSTOMERITEM (legacy OMD0000.edtCUSTOMERSKU) - read-only here; it is
                // stamped by the details grid's Customer SKU picker.
                "name": "CustomerItem",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Customer SKU",
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Ship TO Price Schedule",
        "fields": [
            {
                // OMTRANSACTIONDETAIL.CONSIGNEEITEM (legacy OMD0000.edtConsigneeSKU) - read-only here; it is
                // stamped by the details grid's Ship To SKU picker.
                "name": "ConsigneeItem",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Ship To SKU",
                "readOnly": true,
            },
        ]
    }
]
const OtherChargeLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "Freightrateperitem",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Frt/Item",
            },
            {
                "name": "Handlingchargeperitem",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Handling/Item",
            },
            {
                "name": "Taggingchargeperitem",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Chg/Item",
            },
            {
                "name": "Inventoryreview",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Inv Review",
            }, {
                "name": "Excessquantity",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Excess Qty",
                "readOnly": true,
            },
            {
                "name": "OriginalQuantity",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Original Qty",
                "readOnly": true,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "Effectivefreight",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Effective FRT",
                "readOnly": true,
            },
            {
                "name": "a2",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Comb. Price",
                "readOnly": true,
            },
            {
                "name": "a2",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Landed Price",
                "readOnly": true,
            },
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "PSDetailRetailPrice",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Retail","readOnly": true,
            },
            {
                "name": "PSDetailAlternateSKU",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "SKU",
                "readOnly": true,
            },
            {
                "name": "PSDetailComment",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false, "label": "Override UPC","readOnly": true,
            }
        ]
    }
]
const BackOrderLayout = [
    {
        "groupId": 1,
        "label": "Ordered",
        "fields": [
            {
                "name": "BackReviewBackorderFlag",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "label": "Rev BO Flag",
                "readOnly": true,
            },
            {
                "name": "BackReviewBackorderReason",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "label": "REV BO Rsn",
                "readOnly": true,
            },
            {
                "name": "BackConfirmBackorderFlag",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "label": "Pick Conf Flag",
                "readOnly": true,
            },
            {
                "name": "BackConfirmBackorderReason",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "label": "Pick Conf Rsn",
                "readOnly": true,
            },
        ]
    },
    {
        "groupId": 2,
        "label": "Back Order",
        "fields": [
            {
                "name": "Reviewbackorderflag",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "label": "Rev BO Flag",
                "readOnly": true,
            },
            {
                "name": "Reviewbackorderreason",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "label": "REV BO Rsn",
                "readOnly": true,
            },
            {
                "name": "Confirmbackorderflag",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "label": "Pick Conf Flag",
                "readOnly": true,
            },
            {
                "name": "Confirmbackorderreason",
                "tableName": "OMTRANSACTIONDETAIL",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "label": "Pick Conf Rsn",
                "readOnly": true,
            },
        ]
    }
]
export {
    PrimaryLayout,
    AdditionalLayout,
    UserDefinedLayout,
    UserDefinedLayout1,
    CommentLayout,
    AlternateSKULayout,
    OtherChargeLayout,
    BackOrderLayout
}